// extracted by css-extract-rspack-plugin
export default {"infoBlockContainer":"DashboardAlert_infoBlockContainer__Zph7h","infoBlock":"DashboardAlert_infoBlock__v1IS4","readAction":"DashboardAlert_readAction__D4tZc"};